import { useState, useEffect } from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { QRCodeSVG } from "qrcode.react";
import { X } from "lucide-react";

/**
 * Habano-branded QR modal — reused for business / vendor / custom location.
 * The QR encodes a public HTTPS URL so any phone camera can scan it without
 * Habano installed.
 */
export default function HabanoQRModal({ open, onOpenChange, url, title, subtitle }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="qr-modal"
        className="max-w-md p-0 border-0"
        style={{
          background: "#171717",
          border: "1px solid rgba(232,184,75,0.3)",
          borderRadius: 18,
        }}
        aria-describedby={undefined}
      >
        <div className="flex justify-end p-3">
          <button
            type="button"
            onClick={() => onOpenChange?.(false)}
            aria-label="Close"
            data-testid="qr-modal-close"
            className="text-foreground/70 hover:text-foreground p-2"
          >
            <X className="w-5 h-5" strokeWidth={1.5} />
          </button>
        </div>
        <div className="px-8 pb-10 flex flex-col items-center text-center">
          <div
            className="rounded-xl"
            style={{ padding: 14, background: "#FFFFFF" }}
          >
            <QRCodeSVG
              value={url}
              size={232}
              level="M"
              fgColor="#171717"
              bgColor="#FFFFFF"
              data-testid="qr-modal-svg"
            />
          </div>
          <h2
            data-testid="qr-modal-title"
            className="font-display text-2xl text-foreground mt-7 leading-tight"
          >
            {title}
          </h2>
          <p className="text-[13px] text-foreground/55 mt-2">
            {subtitle || "Scan to view on Habano"}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
